import react, { useEffect, useRef, useState } from "react";
import "../styles/PatientReportFileTemplateCreate.scss";
import asset1 from "../assets/images/asset1.png";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
} from "../Redux/Thunk/Actions";
import { prescriptionType, patientid } from "../Redux/Slice/rootSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../assets/images/ascas.svg";
import { FaSquarePhone } from "react-icons/fa6";
import FigmaHeader from "./FigmaHeader/FigmaHeader";

function PatientReportFileTemplateCreate(props) {
  // const selectedTab = useSelector((state) => state.counter.prescriptionType);
  // const patientId = useSelector((state) => state.counter.patientid);
  const [show, setshow] = useState(false);
  const Content = useRef();
  const [valueChange, setvalueChange] = useState({
    gender1: "Male",
    gender2: "Female",
    bloodGroup1: "A+",
    bloodGroup2: "A+",
    coupleId: "",
  });
  // const [patientid, setpatientid] = useState("");
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const [patientTwo_UUId, setPatientTwo_UUId] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log(valueChange, "lllllll");

  const handleChange = (e) => {
    var text = e.target.value;

    if (e.target.name === "patientId1" || e.target.name === "patientId2") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            if (response.payload.data.data.length === 1) {
              const data = response.payload.data.data[0];
              // const data2 = response.payload.data.data[1];
              const namePat1 =
                data?.titles + " " + data?.first_name + " " + data?.last_name;
              // const namePat2 =
              //   data?.titles + " " + data?.first_name + " " + data?.last_name;
              if (e.target.name === "patientId1") {
                setPatientOne_UUId(data?.id);
                setvalueChange({
                  ...valueChange,
                  patientName1: namePat1,
                  // patientName2: namePat2,
                  age1: data?.age,
                  gender1: data?.gender,
                  patientId1: text,
                });
              }
              if (e.target.name === "patientId2") {
                setPatientTwo_UUId(data?.id);
                setvalueChange({
                  ...valueChange,
                  patientName2: namePat1,
                  age2: data?.age,
                  gender2: data?.gender,
                  patientId2: text,
                });
              }

              props.loaderchange("false");
            }
            // *added for couple ID
            else {
              const data =
                response.payload.data.data[0].gender == "Male"
                  ? response.payload.data.data[0]
                  : response.payload.data.data[1];
              const data2 =
                response.payload.data.data[1].gender == "Female"
                  ? response.payload.data.data[1]
                  : response.payload.data.data[0];
              console.log(data, data2);
              const namePat1 =
                data?.titles + " " + data?.first_name + " " + data?.last_name;
              const namePat2 =
                data2?.titles +
                " " +
                data2?.first_name +
                " " +
                data2?.last_name;

              setPatientOne_UUId(data?.id);
              setPatientTwo_UUId(data2?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat1,
                patientName2: namePat2,
                age1: data?.age,
                age2: data2?.age,
                gender1: data?.gender,
                gender2: data2?.gender,
                patientId1: data?.p_uhid,
                patientId2: data2?.p_uhid,
              });

              props.loaderchange("false");
            }
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
        if (e.target.name === "patientId2") {
          setvalueChange({
            ...valueChange,
            patientId2: e.target.value,
          });
        }
      }
    } else {
      // console.log("Going in");
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
    }
  };
  // const handletest = () => {
  //   setshow(true);
  //   setTimeout(() => {
  //     const CreateThunk = async () => {
  //       let htmlPayload;
  //       htmlPayload = document.getElementById("reportcreate").innerHTML;
  //       console.log(htmlPayload, "liki");
  //       const payload = {
  //         report_template: htmlPayload,
  //         patient_id: patientid,
  //       };
  //       props.loaderchange(true);
  //       const patentReport = postPatientReport({
  //         type: "2",
  //         payload: payload,
  //       });
  //       const response = await dispatch(patentReport);
  //       if (response?.payload?.status?.code === 200) {
  //         props.loaderchange(false);
  //         navigate("/patientreports");
  //         Swal.fire({
  //           title: "Successful.",
  //           text: "Report added successful.",
  //           icon: "success",
  //           showConfirmButton: false,
  //           timer: 1500,
  //         });
  //       } else {
  //         props.loaderchange("false");
  //         props.popupalert("true");
  //         props.popuptext("Network went wrong, Please try after some time.");
  //         // props.popuptext(response?.status?.message);
  //         setTimeout(() => {
  //           props.popupalert("false");
  //         }, 2000);
  //       }
  //     };
  //     CreateThunk();
  //   }, 2000);
  // };

  const handletest = async () => {
    try {
      if (
        valueChange.patientOne_UUId !== "" &&
        // valueChange.setPatientTwo_UUId !== "" &&
        valueChange.patientId1 !== "" &&
        valueChange.patientId1.length === 10 &&
        (valueChange.patientId2 !== ""
          ? valueChange.patientId1 !== valueChange.patientId2
            ? true
            : false
          : true)
      ) {
        // Dispatch action to check couple id
        // const patentReportResponse = await dispatch(
        //   coupleIdChecker({
        //     payload: {
        //       patient_one: valueChange.patientId1,
        //       patient_two: valueChange.patientId2,
        //     },
        //   })
        // );

        // if (patentReportResponse.payload.status.code === 200) {
        //   // Set couple id in state
        //   setvalueChange((prevState) => ({
        //     ...prevState,
        //     coupleId: patentReportResponse.payload.data.couple_id,
        //   }));

        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          console.log(valueChange.coupleId);
          // Get HTML payload
          const htmlPayload = document.getElementById("reportcreate").innerHTML;

          // Prepare payload for creating report
          const payload = {
            report_template: htmlPayload,
            patient_id: patientOne_UUId,
            description: "",
            patient_two: patientTwo_UUId,
            couple_id: valueChange.coupleId,
            template_type: "Sperm Report",
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const reportResponse = await dispatch(
            postPatientReport({ type: "2", payload: payload })
          );

          if (reportResponse?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/patientreports");

            // Show success message
            Swal.fire({
              title: "Successful.",
              text: "Report added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            setshow(false);

            props.loaderchange(false);

            // Show error message
            props.popupalert(true);
            props.popuptext("Network went wrong, Please try after some time.");

            // Hide error message after timeout
            setTimeout(() => {
              props.popupalert(false);
            }, 2000);
          }
        }, 3000);
        // } else {
        //   // Show error message if couple id check fails
        //   setshow(false);

        //   Swal.fire({
        //     title: "Error.",
        //     text: "Bro you have done some thing wrong.",
        //     icon: "error",
        //     showConfirmButton: false,
        //     timer: 1500,
        //   });
        // }
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  useEffect(() => {
    console.log(valueChange, "valueChangevalueChangevalueChange");
  }, [valueChange]);

  return (
    <>
      <div
        style={{ backgroundColor: "white", maxWidth: "100%" }}
        className="patientreport"
        id="reportcreate"
      >
        {/* <div style={{}}> */}
        <>
          {/* <div style={{ width: "100%"}}>
            <img
              className="header_image"
              alt="header"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>   */}
          <FigmaHeader/>

          {/* <div
            style={{
              padding: "10px 20px",
              marginBottom: "5px",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: "200px",
            }}
          >
            <section
              style={{
                marginLeft: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "14px",
                  margin: "0px",
                  gap: "5px",
                }}
              >
                <p
                  style={{ margin: "0px", fontWeight: "200", fontSize: "13px" }}
                >
                  Physician specializing in :
                </p>
                <p
                  style={{ margin: "0px", fontWeight: "600", fontSize: "14px" }}
                >
                  Fertility Obstetrics Laparoscopy <br />
                  Gynecology <br />
                  Ultrasound/3D scan <br />
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontWeight: "600",
                    margin: "0px",
                    display: "flex",
                    alignItems: "end",
                    fontSize: "16px",
                  }}
                >
                  Dr. Aishwarya Parthasarathy
                </p>
              </div>
            </section>
            <section
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <img src={asset1} style={{ maxWidth: "200px" }} />
              <p
                style={{
                  textAlign: "center",
                  fontSize: "13px",
                  fontWeight: "200",
                }}
              >
                24, Chowdry Nagar Main Rd, opp, Vasanthi Dental Hospital,
                Majestic Colony, <br />
                Valasasaravakkam, Chennai, Tamil Nadu 600087
              </p>
            </section>
            <section
              style={{
                marginRight: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <p
                  style={{ margin: "0px", fontWeight: "200", fontSize: "13px" }}
                >
                  For Booking Appointment
                </p>
                <p
                  style={{ fontWeight: "600", margin: "0px", fontSize: "14px" }}
                >
                  <FaSquarePhone
                    style={{
                      display: "inline",
                      marginTop: "-2px",
                      background: "transparent",
                    }}
                    size={18}
                  />{" "}
                  +91 93425 21779
                </p>
                <p
                  style={{ fontWeight: "600", margin: "0px", fontSize: "14px" }}
                >
                  044 4793 9484
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontWeight: "600",
                    textAlign: "right",
                    margin: "0px",
                    fontSize: "16px",
                  }}
                >
                  Dr. Ashwin
                </p>
              </div>
            </section>
          </div> */}
          {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "103px 16px 176px",
              alignItems: "center ",
              maxWidth: "97%",
              paddingBottom: "10px",
            }}
          >
            <span
              className={`input ${!show ? "hide" : "show"}`}
              style={{ fontWeight: 600, fontSize: "20PX" }}
            >
              Couple ID
            </span>
            <span
              className={`input ${!show ? "hide" : "show"}`}
              style={{ fontWeight: 600 }}
            >
              :{" "}
            </span>

            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.coupleId}
            </span>
          </div> */}
        </>
        <div style={{ padding: "10px 20px" }}>
          <div
            style={{
              // display: "grid",
              // gridTemplateColumns: "1fr",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              // flexDirection: "column",
              gap: "3px",
              // marginTop: "130px",
              // overflowX: "hidden",
              // margin: "0 auto",
              // maxWidth: "800"
              // maxWidth: "97%",
              // paddingLeft: "25px",
              border: "1px solid #000",
            }}
            className="report-template-wrap1"
          >
            <div
              className=""
              style={{ width: "100%", display: "block" }}
              id="patientInfo1"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "3px",
                  backgroundColor: "#f7f7f7 ",
                  borderRadius: "6px",
                  padding: "16px 8px 16px 8px",
                  gap: "3px",
                }}
              >
                {/* Patient ID and Couple ID (Side by side) */}
                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "125px 16px 250px",
                      alignItems: "center ",
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>Patient ID</span>
                    <span style={{ fontWeight: 600 }}>: </span>
                    <input
                      type="text"
                      className={`createTime ${show ? "hide" : "show"}`}
                      value={valueChange.patientId1}
                      onChange={(e) => handleChange(e)}
                      name="patientId1"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                      }}
                    />
                    <span
                      className={`input ${!show ? "hide" : "show"}`}
                      style={{ fontSize: "18px" }}
                    >
                      &nbsp;{valueChange.patientId1}
                    </span>
                  </div>
                </div>

                {/* Patient Name */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Male Partner Name</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    value={valueChange.patientName1}
                    name="patientName1"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      color: "#000",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.patientName1}
                  </span>
                </div>
                {/* Gender and Blood Group (Side by side) */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "125px 16px 250px",
                      alignItems: "center ",
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>Gender</span>
                    <span style={{ fontWeight: 600 }}>: </span>
                    <select
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      value={valueChange.gender1}
                      name="gender1"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                        backgroundColor: "white",
                      }}
                    >
                      <option value="" disabled selected>
                        Select Gender
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Others">Others</option>
                      <option value="Decline to State">Decline to State</option>
                    </select>
                    <span
                      className={`input ${!show ? "hide" : "show"}`}
                      style={{ width: "100%", fontSize: "18px" }}
                    >
                      &nbsp;{valueChange.gender1}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Age</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="age1"
                    value={valueChange.age1}
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.age1}
                  </span>
                </div>

                {/* <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center",
                  // paddingLeft: "25px",
                }}
              >
                <span style={{ fontWeight: 600 }}>Blood Group</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  name="bloodGroup1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Blood Group
                  </option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ width: "100%", fontSize: "18px" }}
                >
                  &nbsp;{valueChange.bloodGroup1}
                </span>
              </div> */}
              </div>
            </div>
            <div
              className="patientreportcreate2"
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "#f7f7f7",
              }}
              id="patientInfo2"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "3px",

                  borderRadius: "6px",
                  padding: "16px 8px",
                }}
              >
                {/* Patient ID and Couple ID (Side by side) */}
                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "125px 16px 250px",
                      alignItems: "center ",
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>Patient ID</span>
                    <span style={{ fontWeight: 600 }}>: </span>

                    <input
                      type="text"
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      value={valueChange.patientId2}
                      name="patientId2"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                      }}
                    />
                    <span
                      className={`input ${!show ? "hide" : "show"}`}
                      style={{ width: "100%", fontSize: "18px" }}
                    >
                      &nbsp;{valueChange.patientId2}
                    </span>
                  </div>
                </div>

                {/* Patient Name */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Female Partner Name</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <input
                    type="text"
                    value={valueChange.patientName2}
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="patientName2"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.patientName2}
                  </span>
                </div>

                {/* Gender and Blood Group (Side by side) */}
                <div style={{ display: "flex", gap: "16px" }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "125px 16px 250px",
                      alignItems: "center ",
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>Gender</span>
                    <span style={{ fontWeight: 600 }}>: </span>
                    <select
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="gender2"
                      value={valueChange.gender2}
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                        backgroundColor: "white",
                      }}
                    >
                      <option value="" disabled selected>
                        Select Gender
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Others">Others</option>
                      <option value="Decline to State">Decline to State</option>
                    </select>
                    <span
                      className={`input ${!show ? "hide" : "show"}`}
                      style={{ width: "100%", fontSize: "18px" }}
                    >
                      &nbsp;{valueChange.gender2}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Age</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    value={valueChange.age2}
                    name="age2"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.age2}
                  </span>
                </div>
                {/* <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",

                  alignItems: "center",
                }}
                className="bloodgroup-field"
              >
                <span style={{ fontWeight: 600 }}>Blood Group</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={valueChange.bloodGroup2}
                  name="bloodGroup2"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Blood Group
                  </option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ width: "100%", fontSize: "18px" }}
                >
                  &nbsp;{valueChange.bloodGroup2}
                </span>
              </div> */}
              </div>
            </div>
          </div>
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "start",
                gap: "32px",
                overflowX: "hidden",
                margin: "0 auto",
                width: "100%",
              }}
              className="report-template-wrap2"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* Semen Origin */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "135px 16px 176px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Semen Origin</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="semenOrigin"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.semenOrigin}
                  </span>
                </div>
                {/* Collection Date */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "135px 16px 176px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Collection Date</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="date"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="collectionDate"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.collectionDate}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "10px",
                  // padding: "16px 8px 16px 8px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* Request Dr */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "135px 16px 176px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Request Dr</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="requestDr"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.requestDr}
                  </span>
                </div>

                {/* Result Date */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "135px 16px 176px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Result Date</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="date"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="resultDate"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.resultDate}
                  </span>
                </div>
              </div>
            </div>
          </>
          {/* Spermiogram */}
          <div>
            {/* <h2 style={{ textAlign: "center" }}>Spermiogram</h2>
      <hr></hr> */}
            <h2
              style={{
                textAlign: "center",
                backgroundColor: "#f7f7f7",
                // padding: "16px 8px 16px 8px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "600",
                padding: "10px 0 10px 10px",
              }}
              className="spermiogram-head"
            >
              Spermiogram
            </h2>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "start",
                gap: "32px",
                overflowX: "hidden",
                margin: "0 auto",
              }}
              className="report-template-wrap2"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "3px",
                  // padding: "16px 8px 16px 8px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* Request */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "152px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Request</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="request"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.request}
                  </span>
                </div>

                {/* Collection Type */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "152px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Collection Type</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="collectionType"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.collectionType}
                  </span>
                </div>

                {/* Collection Method */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "152px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Collection Method</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="collectionMethod"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.collectionMethod}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "6px",
                  // padding: "16px 8px 16px 8px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* Abstinence */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "152px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Abstinence</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="abstinence"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.abstinence}
                  </span>
                </div>

                {/* Medication */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "152px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Medication</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="medication"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.medication}
                  </span>
                </div>

                {/* Collection Difficulty */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "152px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Collection Difficulty</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="collectionDifficulty"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.collectionDifficulty}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* macroscopic analysis */}
          <div>
            <h2
              style={{
                textAlign: "center",
                backgroundColor: "#f7f7f7",
                // padding: "16px 8px 16px 8px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "600",
                padding: "10px 0 10px 10px",
              }}
              className="spermiogram-head"
            >
              Macroscopic Analysis
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "start",
                gap: "32px",
                overflowX: "hidden",
                margin: "0 auto",
              }}
              className="report-template-wrap2"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "3px",
                  // padding: "16px 8px 16px 8px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* pH */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 120px 64px",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>pH</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="pH"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.pH}
                  </span>
                  <span>&gt;=7.2</span>
                </div>

                {/* Time of Collection */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 120px",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Time of Collection</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="timeOfCollection"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.timeOfCollection}
                  </span>
                </div>

                {/* Time of Examination */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 120px",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Time of Examination</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="timeOfExamination"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.timeOfExamination}
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "3px",
                  // padding: "16px 8px 16px 8px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* Appearance */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Appearance</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="appearance"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.appearance}
                  </span>
                </div>

                {/* Color */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Color</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="color"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.color}
                  </span>
                </div>

                {/* Homogenosity */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Homogenosity</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="homogenosity"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.homogenosity}
                  </span>
                </div>

                {/* Complete Sample */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Complete Sample</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="completeSample"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.completeSample}
                  </span>
                </div>

                {/* Liquefaction Time */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 16px 176px",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Liquefaction Time</span>
                  <span style={{ fontWeight: 600 }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="liquefactionTime"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.liquefactionTime}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h2
              style={{
                textAlign: "center",
                backgroundColor: "#f7f7f7",
                // padding: "16px 8px 16px 8px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "600",
                padding: "10px 0 10px 10px",
              }}
              className="spermiogram-head"
            >
              Microscopic Analysis
            </h2>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "start",
                gap: "32px",
                overflowX: "hidden",
                margin: "0 auto",
              }}
              className="report-template-wrap2"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "3px",
                  // padding: "16px 8px 16px 8px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* Volume */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 100px 64px",
                    // "256px 16px 240px 64px"
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Volume(ml)</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="volume"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />

                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.volume}
                  </span>
                  <span> &gt;=1.5ml</span>
                </div>

                {/* Concentration */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 100px 64px",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>
                    Concentration (mill/ml)
                  </span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="concentration"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.concentration}
                  </span>
                  <span> &gt;=15</span>
                </div>

                {/* Total */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 100px 64px",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>
                    Total (mill/ejaculate)
                  </span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="total"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.total}
                  </span>
                  <span> &gt;=39</span>
                </div>

                {/* Progressive Motility */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 100px 64px",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>
                    Progressive Motility (%)
                  </span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="progressiveMotility"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.progressiveMotility}
                  </span>
                  <span> &gt;=32%</span>
                </div>

                {/* Non-Progressive Motile */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    // gridTemplateColumns: "256px 16px 240px ",
                    gridTemplateColumns: "256px 16px 100px ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>
                    Non-Progressive Motile (%)
                  </span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="nonProgressiveMotile"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.nonProgressiveMotile}
                  </span>
                </div>

                {/* Immotile */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 100px ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Immotile (%)</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="immotile"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.immotile}
                  </span>
                </div>

                {/* Total Motile Sperm Count */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    // gridTemplateColumns: "256px 16px 240px ",
                    gridTemplateColumns: "256px 16px 100px ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>
                    Total Motile Sperm Count(TMSC)
                  </span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="totalMotileSpermCount"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.totalMotileSpermCount}
                  </span>
                </div>

                {/* Method */}
                {/* <div
                style={{
                  display: "grid",
                  alignItems: "center",
                  gridTemplateColumns: "256px 16px 100px ",
                  gap: "10px",
                }}
              >
                <span style={{ fontWeight: "600" }}>Method</span>
                <span style={{ fontWeight: "600" }}>:</span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  name="method"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ width: "100%", fontSize: "18px" }}
                >
                  &nbsp;{valueChange.method}
                </span>
              </div> */}

                {/* Immature Forms */}
                {/* <div
                style={{
                  display: "grid",
                  alignItems: "center",
                  gridTemplateColumns: "256px 16px 100px ",
                  gap: "10px",
                }}
              >
                <span style={{ fontWeight: "600" }}>Immature Forms</span>
                <span style={{ fontWeight: "600" }}>:</span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  name="immatureForms"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ width: "100%", fontSize: "18px" }}
                >
                  &nbsp;{valueChange.immatureForms}
                </span>
              </div> */}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "3px",
                  // padding: "16px 8px 16px 8px",
                  padding: "5px 8px 5px 8px",
                }}
              >
                {/* Normal */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px 64px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                  className="normal-value-field"
                >
                  <span style={{ fontWeight: "600" }}>Normal</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="normal"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.normal}
                  </span>
                  <span className="value-field">&gt;=4%</span>
                </div>

                {/* Abnormal */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Abnormal</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="abnormal"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.abnormal}
                  </span>
                </div>

                {/* Head Defects */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Head Defects</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="headDefects"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.headDefects}
                  </span>
                </div>

                {/* Midpiece Defects */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Midpiece Defects</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="midpieceDefects"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.midpieceDefects}
                  </span>
                </div>

                {/* Tail Defects */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Tail Defects</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tailDefects"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.tailDefects}
                  </span>
                </div>

                {/* Vitality */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Vitality (%)</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="vitality"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.vitality}
                  </span>
                </div>

                {/* Agglutination */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px 64px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                  className="normal-value-field"
                >
                  <span style={{ fontWeight: "600" }}>Agglutination</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="agglutination"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.agglutination}
                  </span>
                  <span className="value-field">&gt;=58%</span>
                </div>

                {/* Debris */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "131px 16px 100px",
                    alignItems: "center ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Debris</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="debris"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.debris}
                  </span>
                </div>
              </div>
            </div>
            <div style={{ overflowX: "hidden", margin: "0 auto" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "16px 8px 16px 8px",
                }}
                className="report-template-wrap2"
              >
                {/* Leucocytes */}

                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 267px 193px",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Leucocytes </span>
                  <span style={{ fontWeight: "600" }}>:</span>

                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="leucocytes"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.leucocytes}
                  </span>
                  <span>% &lt; 1 mill/ml or 20/field </span>
                </div>
                {/* Diagnosis */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 100% ",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Diagnosis</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="diagnosis"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.diagnosis}
                  </span>
                </div>
                {/* Observations */}
                {/* <div
              style={{
                display: "grid",
                alignItems: "center",
                gridTemplateColumns: "256px 16px 1fr",
                gap: "10px",
                width: "100%",
              }}
            >
              <h3  style={{ fontWeight: "600" }}>Observations</h3>
              <h3  style={{ fontWeight: "600" }}>:</h3>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="observations"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  height: "192px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.observations}
              </span>
            </div> */}
                <div
                  style={{
                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "256px 16px 1fr",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <span style={{ fontWeight: "600" }}>Observations</span>
                  <span style={{ fontWeight: "600" }}>:</span>
                  <textarea
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="observations"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      height: "96px",
                    }}
                  />
                  <span
                    className={`input ${!show ? "hide" : "show"}`}
                    style={{ width: "100%", fontSize: "18px" }}
                  >
                    &nbsp;{valueChange.observations}
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{
                overflowX: "hidden",
                // margin: "64px auto 32px auto",
              }}
            >
              <div
                style={{
                  padding: "16px 8px 16px 8px",
                }}
              >
                <span
                  style={{
                    marginLeft: "65%",
                    display: "block",
                    marginBottom: "16px",
                    fontWeight: "600",
                  }}
                >
                   <pre style={{fontFamily:"system-ui",fontWeight:500}}>Clincian Signature          Andrologist Signature</pre>
                </span>
                <span
                  style={{
                    display: "block",
                    marginBottom: "16px",
                    fontSize: "12px",
                  }}
                >
                  <br/><br/><br/>
                  <strong>
                    *Percentage respect to total number of abnormal spermatoza
                  </strong>
                </span>
                <span style={{ display: "block", fontSize: "12px" }}>
                  New reference values 17-01-2011: Pursuant to the information
                  published by WHO in the Human Reproduction Update, Vol.1.6,
                  No3 pp. 231-245, 2010
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <p style={{textAlign:"center",padding:"30px 10px"}}>x x x End Of Bill x x x</p> */}

      <div className="Footer">
        <button onClick={handletest} className="Button_Create">
          Add Report
        </button>
      </div>
    </>
  );
}

export default PatientReportFileTemplateCreate;
